import Swal from "sweetalert2"
import { Input } from "../Input/Input"
import { CardProduct } from "./ImagemLoja"
import { ImageLoadingOverlay } from "./ImageLoadingOverlay"
import { BaseSyntheticEvent, useEffect, useState, useCallback } from "react"
import Modal from 'react-bootstrap/Modal';
import { LittleButton } from "../Button/LittleButton"
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { i18n } from "../../translate/i18n"

type Props = {
    cardProduct: CardProduct
    hasProductCard: boolean
    isLoading: boolean
    saveProductCard: (cardProduct: CardProduct) => void
}

const defaultCardProduct: CardProduct = {
    image: '',
    value: '',
    description: '',
    urlExternal: '',
}

const croppedOptions = [
    { width: 340, height: 340, value: '340x340' },
]

export function CardImageProduct({ cardProduct, hasProductCard, isLoading, saveProductCard }: Props) {
    const [openModal, setOpenModal] = useState(false)
    const [openModalCropped, setOpenModalCropped] = useState(false)
    const [cardProductImage, setCardProductImage] = useState<CardProduct>(defaultCardProduct)
    const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
    const [imageCrop, setImageCrop] = useState<string | null>('')
    const [isCropped, setCropper] = useState<any>(null)
    const [selectedFormat, setSelectedFormat] = useState<string>('340x340')

    useEffect(() => {
        setCardProductImage(cardProduct)
    }, [cardProduct, isLoading, openModal])

    // Mostrar modal apenas quando imageCrop estiver pronto
    useEffect(() => {
        if (imageCrop) {
            setOpenModalCropped(true)
        }
    }, [imageCrop])

    // Limpar blob URL quando desmontar ou quando resetar imageCrop
    useEffect(() => {
        return () => {
            if (imageCrop) {
                URL.revokeObjectURL(imageCrop)
            }
        }
    }, [imageCrop])

    const validateUrl = (url: string) => {
        if (!url) return true // Campo não obrigatório
        return url.startsWith('http://') || url.startsWith('https://')
    }

    const getImagetoCrop = (file: File) => {
        setOriginalImageFile(file) // Armazenar arquivo original
        const url = URL.createObjectURL(file)
        setImageCrop(url)
    }

    const getCropData = async () => {
        if (isCropped) {
            const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
                .then((res) => res.blob())
                .then((blob) => {
                    return new File([blob], 'newAvatar.png', { type: 'image/png' })
                })

            setCardProductImage({ ...cardProductImage, image: file })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }

    const useOriginalImage = () => {
        if (originalImageFile) {
            setCardProductImage({ ...cardProductImage, image: originalImageFile })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }

    const handleSelectedSize = (width: number, height: number) => {
        if (originalImageFile) {
            // Criar uma cópia do arquivo original com metadados especiais
            const imageWithFormat = Object.assign(originalImageFile, {
                _formatData: {
                    file: originalImageFile,
                    width: width,
                    height: height,
                    isFormatted: true,
                },
            })

            setCardProductImage({ ...cardProductImage, image: imageWithFormat })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }


    return (
        <>
            <div style={{ position: 'relative' }}>
                <Input
                    inputAttr={{
                        type: 'image_modal',
                    }}
                    disabled={hasProductCard}
                    width='100'
                    height='100'
                    imagemBackgroundDefault={'340x340'}
                    value={cardProduct.image ? cardProduct.image : null}
                    change={(value: any) => {
                        Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setCardProductImage(defaultCardProduct)
                                saveProductCard(defaultCardProduct)
                            }
                        })
                    }}
                    action={() => { setOpenModal(true) }}
                />
                <ImageLoadingOverlay isLoading={isLoading} />
            </div>

            <Modal show={openModal} onHide={() => setOpenModal(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Body>
                    <div className='d-flex  flex-column gap-5 card' style={{ height: '40rem', }}                >
                        <div className='card-body d-flex justify-content-between'>
                            <div className='d-flex  flex-column gap-5'>
                                <Input
                                    inputAttr={{
                                        type: 'textarea',
                                    }}
                                    label='Descrição- Resumo sobre o card do produto'
                                    placeholder='A Descrição deva ter no máximo 80 caracteres.'
                                    maxLength='80'
                                    rows={5}
                                    value={cardProductImage && cardProductImage.description}
                                    change={(value: string) => {
                                        setCardProductImage({ ...cardProductImage, description: value })
                                    }}
                                />
                                <Input
                                    inputAttr={{
                                        type: 'money',
                                    }}
                                    currency='BRL'
                                    locale='pt-BR'
                                    label='Valor do produto'
                                    value={cardProductImage && cardProductImage.value}
                                    change={(value: string) => {
                                        setCardProductImage({ ...cardProductImage, value: value })
                                    }}
                                />
                                <Input
                                    inputAttr={{
                                        type: 'text',
                                        maxLength: 350,
                                    }}
                                    label='URL Externa'
                                    placeholder={'http:// ou https://'}
                                    value={cardProductImage && cardProductImage.urlExternal}
                                    change={(value: string) => {
                                        setCardProductImage({ ...cardProductImage, urlExternal: value })
                                    }}
                                />
                                {cardProductImage?.urlExternal && !validateUrl(cardProductImage?.urlExternal) && (
                                    <small className='text-danger mt-1 d-block'>
                                        O link deve começar com http:// ou https://
                                    </small>
                                )}
                            </div>

                            <Input
                                inputAttr={{
                                    type: 'image',
                                }}
                                width='250'
                                height='250'
                                value={cardProductImage && cardProductImage.image}
                                change={(value: BaseSyntheticEvent) => {
                                    const file = value ? value.target.files[0] : null;
                                    if (!file) {
                                        setCardProductImage({ ...cardProductImage, image: '' });
                                        return;
                                    }
                                    const sizeInBytes: number = file ? file.size : 0;
                                    const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                                    const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));
                                    if (sizeInMB > 2) {
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Erro',
                                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                                        });
                                        return;
                                    }
                                    getImagetoCrop(file)
                                    //setCardProductImage({ ...cardProductImage, image: file });
                                }}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <LittleButton
                        text={'Salvar'}
                        color={'primary'}
                        click={() => {
                            saveProductCard(cardProductImage);
                            setOpenModal(false);
                        }}
                        width='110px'
                        height='35px'
                    />
                </Modal.Footer>
            </Modal>

            <Modal show={openModalCropped} onHide={() => setOpenModalCropped(false)}
                size="xl"

                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Body style={{ paddingLeft: 0, paddingRight: 0 ,  paddingBottom: 0}}>
                    <div
                        className={`modal-content`}
                        style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
                    >
                        <div className='modal-header'>
                            <h5 className='modal-title'>{i18n.t(`smart_order.crop_image`)}</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                onClick={() => setOpenModalCropped(false)}
                            >
                                <i className='fa fa-times' aria-hidden='true'></i>
                            </div>
                        </div>
                        <div
                            className='modal-body text-break pt-4 d-flex justify-content-center flex-grow-1 overflow-auto'
                            style={{ minHeight: '300px' }}
                        >
                            <div className='w-100 d-flex flex-column align-items-center'>
                                <div className='mb-3'>
                                    <Cropper
                                        src={imageCrop ? imageCrop : ''}
                                        style={{ height: '300px', width: '400px', maxWidth: '100%' }}
                                        initialAspectRatio={4 / 3}
                                        minCropBoxHeight={100}
                                        minCropBoxWidth={100}
                                        guides={false}
                                        checkOrientation={false}
                                        onInitialized={(instance: any) => {
                                            setCropper(instance)
                                        }}
                                    />
                                </div>

                                {/* Seleção de formato */}
                                <div className='mb-3'>
                                    <h6 className='text-center mb-2'>
                                        {i18n.t(`smart_order.select_image_format`)}
                                    </h6>
                                    <div className='d-flex justify-content-center gap-3'>
                                        {croppedOptions.map((option) => (
                                            <label className='d-flex align-items-center' key={option.value}>
                                                <input
                                                    type='radio'
                                                    name='imageFormat'
                                                    value={option.value}
                                                    checked={selectedFormat === option.value}
                                                    onChange={(e) => setSelectedFormat(e.target.value)}
                                                    className='me-2'
                                                />
                                                {option.value} ({option.width}x{option.height})
                                            </label>
                                        ))}


                                    </div>
                                </div>

                                {/* Mensagem explicativa sobre o recorte */}
                                <div className='mb-3 text-center'>
                                    <small className='text-muted fst-italic'>
                                        <strong>Dica:</strong> Use "Recortar imagem" apenas quando desejar dar ênfase
                                        a uma parte específica da imagem, destacando melhor a área recortada.
                                    </small>
                                </div>

                                <div className='d-flex justify-content-center flex-wrap gap-2'>
                                    <button className='btn btn-secondary px-3 py-2' onClick={useOriginalImage}>
                                        {i18n.t(`smart_order.use_original_image`)}
                                    </button>
                                    <button className='btn btn-primary px-3 py-2' onClick={() => handleSelectedSize(340, 340)}>
                                        {i18n.t(`smart_order.use_selected_size`)}
                                    </button>
                                    <button className='btn btn-dark px-3 py-2' onClick={getCropData}>
                                        {i18n.t(`smart_order.crop_image`)}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer d-flex justify-content-end border-top pt-3'>
                            <button
                                type='button'
                                className='btn btn-light px-4'
                                onClick={() => setOpenModalCropped(false)}
                            >
                                {i18n.t(`buttons.close`)}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}